import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getGlobalConfiguration: {
    method: 'GET',
    url: `${configs.baseUrl}/api/global-configuration`,
  },
  updateGlobalConfiguration: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/global-configuration`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getGlobalConfiguration = async () => {
  const res = await resource.getGlobalConfiguration()
  return res.body
}

const updateGlobalConfiguration = async (params) => {
  const res = await resource.updateGlobalConfiguration(params)
  
  return res.body
}

export default {
  initResource,
  getGlobalConfiguration,
  updateGlobalConfiguration,
}
